import { Circle, Image } from 'native-base'
import React from 'react'

import { Images } from '~images'

export const LogoWithGradient = ({ size = '20' }: { size: number | string }): JSX.Element => {
  return (
    <Circle
      size={size}
      overflow="hidden"
      p="1.5"
      bg={{
        linearGradient: {
          colors: ['offBlue', 'actionBlue'],
          start: [0, 0],
          end: [0.4, 0.5],
        },
      }}
    >
      <Image source={Images.SYGNET} size="full" resizeMode="contain" ignoreFallback alt="logo" />
    </Circle>
  )
}
